module.exports = __webpack_public_path__ + "img/trailhead_logo.3d02a13a.png";